import { render, staticRenderFns } from "./404.vue?vue&type=template&id=a6f5fb2a&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=a6f5fb2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f5fb2a",
  null
  
)

export default component.exports